/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CellValue
 */
export interface CellValue {
    /**
     * 
     * @type {string}
     * @memberof CellValue
     */
    readonly sigla?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CellValue
     */
    readonly colore?: string | null;
}

/**
 * Check if a given object implements the CellValue interface.
 */
export function instanceOfCellValue(value: object): value is CellValue {
    return true;
}

export function CellValueFromJSON(json: any): CellValue {
    return CellValueFromJSONTyped(json, false);
}

export function CellValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): CellValue {
    if (json == null) {
        return json;
    }
    return {
        
        'sigla': json['sigla'] == null ? undefined : json['sigla'],
        'colore': json['colore'] == null ? undefined : json['colore'],
    };
}

export function CellValueToJSON(json: any): CellValue {
    return CellValueToJSONTyped(json, false);
}

export function CellValueToJSONTyped(value?: Omit<CellValue, 'sigla'|'colore'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

